export default __webpack_public_path__ + "static/card-cta-019728a8fec66bbe255e70457f48e4a7.png";